var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConseils(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 433,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M461.082 139.206C461.082 62.337 395.704.037 315.036.037c-80.669 0-146.046 62.3-146.046 139.169 0 46.642 24.073 87.931 61.046 113.183 15.693 10.707 25.185 28.378 25.185 47.377v10.659c0 23.144 18.747 41.905 41.873 41.905h35.884c23.126 0 41.873-18.761 41.873-41.905v-10.659c0-18.999 9.515-36.67 25.185-47.377 36.973-25.252 61.046-66.541 61.046-113.183Z",
    fill: "#F5F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.035 431.52c17.897 0 32.405-7.689 32.405-17.174s-14.508-17.174-32.405-17.174c-17.896 0-32.404 7.689-32.404 17.174s14.508 17.174 32.404 17.174Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.979 383.693v17.53c0 5.922 3.362 11.37 8.711 13.928 7.433 3.554 19.765 7.439 37.707 6.965 14.557-.379 24.049-2.748 30.085-5.259 5.823-2.416 9.563-8.172 9.563-14.497v-9.689l-86.089-8.978h.023Z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M271.979 399.043a16.673 16.673 0 0 0 4.545 3.175c8.332 3.979 62.892 12.862 76.053 7.912a17.612 17.612 0 0 0 4.592-2.535c.568-1.658.899-3.411.899-5.235v-9.689l-86.089-8.978v15.35Z",
    fill: "url(#c)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.814 371.754c-4.852-.498-9.066 3.293-9.066 8.172v.498c0 6.656 3.788 12.744 9.776 15.61 8.332 3.98 62.892 12.863 76.053 7.912 6.627-2.487 10.722-8.196 10.722-15.279v-.402c0-4.217-3.171-7.746-7.361-8.173l-80.148-8.362.024.024Z",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "m355.961 380.116-80.147-8.362a8.15 8.15 0 0 0-7.669 3.625 17.205 17.205 0 0 0 8.402 8.812c8.332 3.979 65.236 14.023 76.053 8.906 4.214-1.989 7.527-5.353 9.303-9.427a8.218 8.218 0 0 0-5.942-3.554Z",
    fill: "url(#e)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.666 343.375a5.947 5.947 0 0 0-5.941 5.946v13.739c0 6.657 3.787 12.745 9.775 15.611 8.332 3.98 65.236 14.024 76.053 8.907 6.415-3.009 10.723-9.191 10.723-16.274v-21.983c0-3.269-2.651-5.946-5.941-5.946h-84.716.047Z",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.036 358.773c26.015 0 47.104-4.985 47.104-11.134 0-6.148-21.089-11.133-47.104-11.133s-47.104 4.985-47.104 11.133c0 6.149 21.089 11.134 47.104 11.134Z",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M461.082 139.206C461.082 62.337 395.704.037 315.036.037c-80.669 0-146.046 62.3-146.046 139.169 0 46.642 24.073 87.931 61.046 113.183 15.693 10.707 25.185 28.378 25.185 47.377v10.659c0 23.144 18.747 41.905 41.873 41.905h35.884c23.126 0 41.873-18.761 41.873-41.905v-10.659c0-18.999 9.515-36.67 25.185-47.377 36.973-25.252 61.046-66.541 61.046-113.183Z",
    fill: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.036 347c19.033 0 34.463-3.648 34.463-8.149 0-4.5-15.43-8.148-34.463-8.148-19.034 0-34.464 3.648-34.464 8.148 0 4.501 15.43 8.149 34.464 8.149Z",
    fill: "#F5F7FA",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M306.041 343.826a1.972 1.972 0 0 1-1.965-1.729l-25.351-197.3a1.997 1.997 0 0 1 1.728-2.227c1.089-.142 2.083.64 2.225 1.729l25.351 197.3a1.996 1.996 0 0 1-1.728 2.227h-.26Z",
    fill: "url(#i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M321.782 343.826h-.261a1.996 1.996 0 0 1-1.728-2.227l25.351-197.3c.142-1.089 1.136-1.871 2.225-1.729a1.996 1.996 0 0 1 1.728 2.227l-25.351 197.3c-.118.995-.994 1.729-1.964 1.729Z",
    fill: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.446 144.631a1.958 1.958 0 0 1-1.657-.901l-7.006-10.612s-.19-.166-.284-.166a.285.285 0 0 0-.261.166l-4.615 7.746a4.312 4.312 0 0 1-3.598 2.108c-1.468.048-2.864-.687-3.693-1.918l-6.343-9.523s-.166-.166-.284-.166c-.142.024-.19.047-.261.142l-5.562 8.054c-.805 1.161-2.131 1.872-3.527 1.872a4.3 4.3 0 0 1-3.527-1.848l-8.024-11.513s-.166-.142-.284-.142a.292.292 0 0 0-.261.166l-7.338 12.673a2.003 2.003 0 0 1-2.722.735 2.007 2.007 0 0 1-.733-2.724l7.337-12.674a4.368 4.368 0 0 1 3.551-2.155c1.468-.071 2.864.639 3.716 1.847l8.024 11.513s.166.142.261.142c0 0 .189-.047.26-.142l5.563-8.054a4.313 4.313 0 0 1 3.574-1.872c1.42 0 2.746.735 3.55 1.943l6.344 9.523s.189.189.284.165a.284.284 0 0 0 .261-.165l4.615-7.746a4.26 4.26 0 0 1 3.598-2.109 4.329 4.329 0 0 1 3.693 1.943l7.006 10.612a1.995 1.995 0 0 1-.568 2.772c-.331.213-.71.331-1.089.331v-.023Z",
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M317.687 248.978c3.124-53.631 93.498-66.186 93.095-114.107-.236-29.492-36.144-51.404-43.814-55.81-56.501-32.334-126.044 4.998-140.388-21.414-3.574-6.585-1.894-13.74-.947-17.814 1.444-6.158 4.71-11.915 9.563-17.15-39.861 24.85-66.206 67.749-66.206 116.547s24.073 87.931 61.046 113.182c15.693 10.708 25.185 28.379 25.185 47.377v10.66c0 23.143 18.747 41.904 41.873 41.904h35.884c23.126 0 41.873-18.761 41.873-41.904v-8.504c-4.947 3.79-10.605 6.419-16.83 6.372-21.587-.166-41.873-32.595-40.334-59.292v-.047Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.356 265.915c69.403 0 125.665-54.301 125.665-121.285 0-66.983-56.262-121.284-125.665-121.284-69.404 0-125.666 54.301-125.666 121.284 0 66.984 56.262 121.285 125.666 121.285Z",
    fill: "#F5F7FA",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.44
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m176.161 184.309-27.22-4.525-16.286 9.76-27.433-9.025s-24.215 3.221-24.736 3.032l25.895 241.502c6.959 3.814 15.883 6.704 27.174 7.154 10.32.403 19.67-.261 27.789-1.421 7.74-17.909 30.535-73.126 43.175-130.405 15.385-69.738-28.358-116.096-28.358-116.096v.024Z",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.304 203.804S7.25 209.276 1.57 257.411c-5.681 48.158 10.462 70.662 17.35 86.368 6.888 15.705 39.364-19.922 53.329-33.567 13.942-13.644-31.505-107.308-53.945-106.408Z",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.832 200.038c0-.735 7.101-12.508 7.101-12.508s19.221 8.718 36.31 50.764c17.067 42.047 19.079 82.909 12.593 95.796-6.486 12.91-49.376-12.673-57.874-30.582-8.497-17.908 1.87-103.47 1.87-103.47Z",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.219 270.25c-5.918-26.057-20.286-82.743-20.286-82.743l-50.394-6.586s42.062 64.93 37.304 119.461c-4.047 46.452-29.658 112.472-37.162 130.996 6.06-.687 11.551-1.658 16.356-2.771 8.9-22.315 59.626-134.29 54.158-158.357h.024Z",
    fill: "url(#p)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.441 137.264s-3.645 37.735-4.758 44.036l30.487 11.773 15.457-10.28-8.853-40.555-32.333-4.974Z",
    fill: "url(#q)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.135 107.7c.497.379 3.811 24.612 3.527 28.663-.284 4.051 3.977 13.147 3.977 13.147s-13.563 7.865-20.759 6.491c-7.196-1.374-18.297-16.724-20.309-22.599-1.989-5.875 10.486-19.472 10.486-19.472l23.055-6.23h.023Z",
    fill: "url(#r)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.559 147.473s5.799 19.685 7.385 20.349c12.806 5.401 29.801 8.93 34.961-.829 3.196-6.041.521-14.972-5.302-22.386-.947.971-8.071 7.983-17.563 6.775-9.729-1.256-17.99-10.636-18.558-22.717 0 0-1.231-3.103 1.989-4.288 3.219-1.184 19.173-9.57 22.865-9.309 3.693.26 8.356 1.824 10.51 1.8 2.154-.047 7.645-3.53 7.077-10.66-.568-7.106-6.485-7.746-6.485-7.746.97-.332 6.343-2.25 8.781-7.864 2.58-5.899.947-13.716-2.982-15.61-3.148-1.517-6.32 1.397-21.611 11.867-13.066 8.93-19.599 13.384-22.747 15.303-11.93 7.248-16.877 8.764-19.244 14.9-2.225 5.708-.592 11.133-.095 12.768 4.071 13.455 19.93 17.387 21.019 17.624v.023Z",
    fill: "url(#s)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.109 142.191s-1.964-5.046-4.805-3.672c-2.84 1.374 2.959 8.978 7.03 10.233l-2.225-6.561Z",
    fill: "url(#t)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.465 244.217s4.213-20.562 4.285-21.296c.047-.592-23.837-29.397-34.488-41.573l-14.013-2.914s43.885 67.441 39.127 121.971c-2.935 33.519-15.575 77.201-26.061 105.887 44.121-90.016 49.589-144.83 49.589-144.83l-18.462-17.222.023-.023Z",
    fill: "url(#u)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m130.241 200.914-6.769-14.426s7.432-3.719 18.581-.64l-3.48 13.811c-.284 1.99-1.87 3.506-3.858 3.742a4.39 4.39 0 0 1-4.474-2.487Z",
    fill: "url(#v)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m136.893 182.556 13.681 19.353 5.965-20.964-6.935-7.793-12.711 9.404ZM103.162 174.407l-4.355 6.941 20.286 21.675 8.521-19.472-24.452-9.144Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.807 181.348c-40.5 2.108-80.503 22.433-80.503 22.433 33.99 32.145 62.727 157.006 73.591 209.594 4.734 5.449 12.072 11.608 22.842 15.374 12.498-101.007-15.906-247.401-15.906-247.401h-.024Z",
    fill: "url(#w)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.702 406.292s17.185-174.867-17.895-224.921L84.605 221.76l17.966 22.48-12.972 21.722s30.18 54.815 27.103 140.353v-.023Z",
    fill: "url(#x)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.352 340.841c-.332-.805-17.966-40.104-3.409-57.681 14.534-17.553 80.03-44.771 105.238-71.16 0 0 6.652 1.161 8.19 5.236 0 0-44.476 111.808-100.29 129.859 0 0-6.179 2.037-9.73-6.254Z",
    fill: "url(#y)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.111 199.161c8.238 22.694 5.374 36.362 1.018 44.771-7.953 15.279-21.895 15.019-57.045 39.607-30.772 21.533-32.736 30.558-32.097 35.675.9 7.225 7.196 8.03 12.71 22.693 3.835 10.21 3.457 16.937 7.386 18.027 3.243.9 6.225-2.961 12.332-8.078 4.9-4.098 11.977-9.12 21.753-13.597.308-3.577 1.09-9.12 3.527-15.373 10.107-25.868 33.328-24.66 48.288-48.348 9.042-14.308 13.799-35.651 5.799-53.844-5.066-11.512-13.776-18.429-19.149-21.983-1.492.143-2.983.308-4.451.45h-.071Z",
    fill: "url(#z)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M155.734 220.694a46.469 46.469 0 0 0-1.42-2.89c2.225 17.956 1.089 38.067-11.125 52.091-16.309 18.714-39.529 11.915-58.868 26.957-11.385 8.86-21.871 25.655-23.268 59.647.71 1.824 1.563 3.009 3.006 3.411 3.243.901 6.226-2.961 12.333-8.077 4.9-4.098 11.977-9.12 21.753-13.597.307-3.577 1.088-9.12 3.526-15.374 10.108-25.868 33.328-24.66 48.288-48.348 9.042-14.308 13.8-35.651 5.799-53.844l-.024.024Z",
    fill: "url(#A)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M121.625 212.758s2.959-14.426 9.208-18.026c6.249-3.601 19.978-4.264 19.978-4.264s-5.042 9.949-9.421 10.944c-4.379 1.018-13.279 5.922-13.705 10.588-.426 4.667-6.06 2.985-6.06.758Z",
    fill: "url(#B)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.268 260.704s-6.059-14.047-13.729-18.216c-7.669-4.17-15.717-2.464-15.835-1.256-.118 1.208-1.278 8.078 4.119 9.736 5.396 1.658 12 6.348 14.178 8.765 2.178 2.44 8.285 6.206 8.285 6.206l2.982-5.235Z",
    fill: "url(#C)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m171.499 257.411-7.504 11.063a1116.473 1116.473 0 0 0 21.801 26.104c22.842 26.484 34.464 37.38 49.565 41.952 4.237 1.279 13.256 3.885 18.605-.734.781-.687 3.054-2.843 4-8.433 2.036-12.129-5.112-22.931-7.503-26.555-9.989-15.113-38.867-31.813-78.988-43.397h.024Z",
    fill: "url(#D)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 184.588,
    y1: 304.195,
    x2: 161.594,
    y2: 159.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 311.982,
    y1: 438.721,
    x2: 314.589,
    y2: 417.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 271.979,
    y1: 397.646,
    x2: 358.068,
    y2: 397.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 303.792,
    y1: 407.026,
    x2: 329.434,
    y2: 357.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 268.121,
    y1: 383.125,
    x2: 361.879,
    y2: 383.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 266.725,
    y1: 366.164,
    x2: 363.323,
    y2: 366.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 312.621,
    y1: 358.868,
    x2: 322.151,
    y2: 314.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 294.372,
    y1: 110.235,
    x2: 483.253,
    y2: 409.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FAB848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FCC345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAB847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F49B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F39252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 259.884,
    y1: 341.078,
    x2: 298.424,
    y2: 228.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 296.667,
    y1: 353.68,
    x2: 335.208,
    y2: 241.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 246.487,
    y1: 336.482,
    x2: 285.027,
    y2: 224.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 300.976,
    y1: 42.652,
    x2: 263.307,
    y2: 352.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B14C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FAB848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FBC045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FCC345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAB847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F49B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F39252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 80.486,
    y1: 306.043,
    x2: 207.809,
    y2: 306.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 66.355,
    y1: 379.761,
    x2: 5.724,
    y2: 201.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 227.384,
    y1: 297.397,
    x2: 204.414,
    y2: 152.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 301.307,
    y1: 419.794,
    x2: 327.28,
    y2: 373.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26274F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444C8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 126.17,
    y1: 194.21,
    x2: 129.181,
    y2: 114.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 134.809,
    y1: 138.803,
    x2: 99.835,
    y2: 84.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 166.433,
    y1: 100.689,
    x2: 85.546,
    y2: 170.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#913501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#441400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 112.062,
    y1: 137.477,
    x2: 84.604,
    y2: 169.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 224.852,
    y1: 265.347,
    x2: 140.661,
    y2: 300.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36286C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 123.543,
    y1: 204.017,
    x2: 25.804,
    y2: 341.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 116.299,
    y1: 362.801,
    x2: 55.692,
    y2: 184.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 104.086,
    y1: 296.378,
    x2: 161.988,
    y2: 256.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 102.949,
    y1: 360.171,
    x2: 67.325,
    y2: 262.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 71.563,
    y1: 294.483,
    x2: 161.399,
    y2: 245.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 77.954,
    y1: 306.351,
    x2: 167.814,
    y2: 257.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26274F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 143.165,
    y1: 188.596,
    x2: 112.433,
    y2: 233.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 146.835,
    y1: 234.149,
    x2: 169.8,
    y2: 285.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 163.995,
    y1: 297.918,
    x2: 258.345,
    y2: 297.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#180047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B306E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConseils);
export default __webpack_public_path__ + "static/media/conseils.7a88afbd039c63d298f278b830591de8.svg";
export { ForwardRef as ReactComponent };